import { BaseApi } from './base.api.js';

export class UnitApi extends BaseApi {
    constructor(client) {
        super(client, '/unit');
    }
}
